import { HvorMyeRoutes } from 'appData/routes';
import { useCallback } from 'react';
import { useNavigate } from 'react-router';

export const useVeiviserNavigator = () => {
    const navigate = useNavigate();

    const goToRoute = useCallback(
        (path: HvorMyeRoutes) => {
            void navigate(path);
        },
        [navigate],
    );

    return { goToRoute };
};
